// Deutsch (Standardsprache) — Quelle für die Struktur aller Übersetzungen.
export const de = {
  code: "de",
  label: "Deutsch",
  ui: {
    skipToContent: "Zum Inhalt springen",
    mainNav: "Hauptnavigation",
    mobileNav: "Navigation mobil",
    menuOpen: "Menü öffnen",
    menuClose: "Menü schließen",
    sending: "Wird gesendet …",
    languageLabel: "Sprache",
    backToHome: "Zur Startseite",
    legalPlaceholder: "Platzhalter: Dieser Text muss vor dem Livegang durch die echten Angaben des Betreibers ersetzt werden.",
    legalTranslationNote: "Maßgeblich ist die deutsche Fassung. Diese Übersetzung dient nur dem Verständnis.",
    corporateLogin: "Business"
  },
  brand: {
    name: ["Positiv", "up"],
    tagline: "See. Measure. Grow.",
    domain: "positivup.com"
  },
  nav: [{
    label: "Leistungen",
    href: "#leistungen"
  }, {
    label: "Unterschied",
    href: "#unterschied"
  }, {
    label: "So funktioniert's",
    href: "#ablauf"
  }, {
    label: "Preise",
    href: "#preise"
  }, {
    label: "FAQ",
    href: "#faq"
  }],
  cta: "Kostenlos prüfen",
  hero: {
    eyebrow: "Digitale Bestandsaufnahme für lokale Unternehmen",
    headline: ["Das digitale Röntgenbild", "Ihres Unternehmens"],
    subline: "Wir scannen Ihre gesamte digitale Substanz — vom ersten Tag bis heute. Der Bericht zeigt Stärken und Schwächen Ihrer digitalen Infrastruktur und prüft, ob sie im Zeitalter der KI-Assistenten noch tragfähig ist.",
    reassurance: "Kostenlos · Kein Login · Ergebnis als Link",
    cta: {
      primary: "Kostenlos analysieren",
      whatsapp: "Kontakt über WhatsApp",
      whatsappHref: "https://wa.me/"
    },
    panel: {
      title: "Auszug aus dem Befund",
      caption: "Beispieldarstellung mit Musterwerten.",
      history: {
        label: "Digitale Spur",
        value: "Aktiv seit 2014",
        note: "11 Jahre Verlauf ausgewertet: Domain, Profile, Einträge, Inhalte."
      },
      ai: {
        label: "KI-Tauglichkeit Ihrer Infrastruktur",
        value: "82 % vorbereitet",
        note: "Maschinenlesbare Struktur, klare Angaben, zitierfähige Inhalte."
      },
      local: {
        label: "Lokale Auffindbarkeit",
        value: "Position 4",
        note: "Nur ein kleiner Teil des Berichts — Karten-Pins sind der Anfang, nicht das Ergebnis."
      },
      score: {
        label: "Gesamtbefund",
        caption: "von 100 Punkten"
      }
    }
  },
  problem: {
    title: "Warum Sie davon nichts merken",
    lead: "Sie verlieren keine Kundschaft, weil jemand Sie abgelehnt hat. Sie verlieren sie, weil Sie nicht in der Auswahl waren.",
    cards: [{
      title: "Die Suche endet bei den Maps-Ergebnissen",
      body: "Die meisten Menschen tippen „Friseur in der Nähe“ und entscheiden aus den ersten Kartentreffern. Was darunter liegt, wird selten geöffnet."
    }, {
      title: "KI-Assistenten antworten direkt",
      body: "Auf „welcher Friseur ist gut in Elberfeld“ nennen ChatGPT und Claude heute konkrete Namen — mit Web-Suche, aus Bewertungen und Webseiten."
    }, {
      title: "Unsichtbar heißt: nicht verglichen",
      body: "Wer in Karte und KI-Antwort fehlt, tritt gar nicht erst gegen den Wettbewerb an. Preis, Qualität und Service spielen dann keine Rolle mehr."
    }]
  },
  audience: {
    title: "Für wen ist diese Analyse?",
    lead: "Wenn eine dieser Situationen auf Ihr Unternehmen zutrifft, können Sie mit unserer Digital-Assets-Analyse Ihre Sichtbarkeit erhöhen.",
    items: [{
      title: "Sie bekommen nicht genug Kunden",
      body: "Wenn die Zahl der Kunden unter Ihren Erwartungen liegt, steckt das Problem meist nicht an einer einzelnen Stelle — sondern in Ihrer gesamten digitalen Präsenz."
    }, {
      title: "Sie sind auf Google Maps oder in der Suche nicht auffindbar",
      body: "Wenn potenzielle Kunden Ihr Unternehmen bei Google nicht finden, gibt es ein ernsthaftes Problem mit Ihrer Karten- und Suchranking."
    }, {
      title: "KI-Tools wie ChatGPT empfehlen Sie gar nicht",
      body: "Kunden fragen zunehmend nicht Google, sondern KI-Assistenten. Wenn Ihr Name in dieser neuen Suchform nie fällt, verlieren Sie schon heute zukünftige Kunden."
    }, {
      title: "Ihre Wettbewerber sind sichtbarer als Sie",
      body: "Wenn Konkurrenten in derselben Branche in Suche, Karte und KI-Empfehlungen vor Ihnen erscheinen, müssen Sie wissen, was sie anders machen."
    }, {
      title: "Auf Ihrer Website könnten unbemerkte Risiken lauern",
      body: "Die meisten Unternehmer wissen nicht, ob ihre Website rechtliche oder technische Lücken hat — das sind Probleme, die unbemerkt wachsen."
    }],
    note: "Wenn eine dieser Situationen auf Sie zutrifft, starten Sie mit der kostenlosen Analyse.",
    ctaTitle: "Lassen Sie uns Ihren individuellen Bericht erstellen!",
    ctaBody: "Finden Sie mit der kostenlosen Analyse in 2 Minuten heraus, wo Sie gerade stehen.",
    ctaButton: "Kostenlosen Bericht sichern →"
  },
  areas: {
    title: "Was wir messen",
    lead: "Ein Score aus 100 Punkten über sechs Bereiche — jeder Bereich mit nachvollziehbaren Einzelprüfungen.",
    items: [{
      icon: "monitor",
      label: "Website & Technik",
      max: 18,
      line: "Ladezeit, mobile Darstellung, Verschlüsselung und technische Grundlagen Ihrer Seite."
    }, {
      icon: "search",
      label: "On-Page-SEO",
      max: 20,
      line: "Titel, Überschriften, Texte und Struktur — versteht Google, was Sie anbieten?"
    }, {
      icon: "mapPin",
      label: "Local SEO",
      max: 13,
      line: "Adresse, Öffnungszeiten, Einträge in Verzeichnissen und Ihre Auffindbarkeit im Umfeld."
    }, {
      icon: "store",
      label: "Google-Unternehmensprofil",
      max: 20,
      line: "Vollständigkeit, Kategorien, Fotos, Beiträge und Ihre Position auf der Karte."
    }, {
      icon: "star",
      label: "Bewertungen",
      max: 17,
      line: "Menge, Aktualität, Verteilung, Antwortverhalten und wiederkehrende Themen."
    }, {
      icon: "sparkles",
      label: "KI-Sichtbarkeit",
      max: 12,
      line: "Werden Sie in echten Empfehlungsfragen an KI-Assistenten genannt — und wie?"
    }],
    highlights: [{
      icon: "scale",
      label: "Rechtliche Risiken & Bildrechte-Prüfung",
      line: "Impressum, Cookie-Einwilligung und ob Fotos auf Ihrer gesamten Website tatsächlich frei verwendet werden dürfen — mit Beleg-Links."
    }, {
      icon: "target",
      label: "Wettbewerbsvergleich vor Ort",
      line: "Die drei stärksten Mitbewerber in Ihrer Region — nicht nur im Gesamtscore, sondern in jeder Unterkategorie wie SEO, Reputation und KI-Sichtbarkeit."
    }, {
      icon: "route",
      label: "Priorisierter 3-Monats-Plan",
      line: "Jede Feststellung wird von einem Experten geprüft und in einen konkreten, nach Impact und Aufwand sortierten Fahrplan übersetzt."
    }]
  },
  different: {
    title: "Was Positivup anders macht",
    lead: "Kein Dashboard mit Kennzahlen, sondern eine Einschätzung, mit der Sie oder Ihre Agentur direkt arbeiten können.",
    steps: [{
      kicker: "Schritt 1",
      title: "Maps-Position und Sichtbarkeits-Heatmap",
      body: "Ihre Position wird nicht an einem Punkt gemessen, sondern an einem Raster von Messpunkten über die Stadt — typischerweise 4×4 bis 6×6, je nach Gebiet. An der eigenen Adresse auf Platz 1 und drei Straßen weiter unsichtbar ist der Normalfall. Die organische Google-Position wird getrennt davon erhoben und separat ausgewiesen."
    }, {
      kicker: "Schritt 2",
      title: "Echter KI-Test mit zwei Assistenten",
      body: "Wir stellen ChatGPT und Claude mit aktiver Web-Suche echte Empfehlungsfragen — auch in Varianten mit Ihren tatsächlichen Stadtteilen. Der Bericht zeigt „in X von N Anfragen genannt“, die genauen Fragen und je Nennung, ob über Sie empfehlend, neutral oder negativ gesprochen wurde."
    }, {
      kicker: "Schritt 3",
      title: "Rechte-Check inklusive Bildrechte",
      body: "Impressum, Datenschutzerklärung, AGB, Tracking vor der Einwilligung, Google Fonts von Google-Servern, Einbettungen ohne Consent — dazu Bilder, deren Herkunft auf eine Stock-Agentur hindeutet, geprüft per Rückwärts-Bildsuche mit Beleg-Links. Dies ist keine Rechtsberatung."
    }, {
      kicker: "Schritt 4",
      title: "Tiefe Bewertungs- und Reputationsanalyse",
      body: "Nicht die fünf Bewertungen, die Google zeigt, sondern bis zu 50 echte Bewertungen nach Datum: wie viele in den letzten 30, 90 und 365 Tagen kamen, der Anteil negativer Bewertungen, die Antwortquote und ob Ihre Antworten individuell oder wie Vorlagen wirken, wiederkehrende Lob- und Kritikthemen mit Anzahl — und ein Vergleich mit den stärksten Mitbewerbern vor Ort, namentlich."
    }, {
      kicker: "Schritt 5",
      title: "Priorisierter Drei-Monats-Plan",
      body: "Jede Feststellung endet in einem konkreten nächsten Schritt, sortiert nach Wirkung und Aufwand. Ein Mensch prüft den Plan, bevor er zu Ihnen geht."
    }],
    pillars: ["Für lokale Unternehmen in Deutschland gebaut, nicht für nationale Online-Shops.", "Klassische lokale Sichtbarkeit und KI-Sichtbarkeit in einem Score.", "Zwei KI-Assistenten, echte lokale Fragen — samt Tonalität der Nennung.", "Deutsche Rechtsrealität inklusive: Impressum, Consent, Bildrechte.", "Ein Mensch prüft jeden Bericht, bevor er versendet wird.", "39 € einmalig. Kein Abo, kein Vertrag."]
  },
  moreChecks: {
    title: "Und außerdem im Bericht",
    items: [{
      title: "Echte Kundenfragen",
      body: "Die Fragen, die Menschen rund um Ihre Leistung wirklich bei Google eintippen (aus Googles eigener Autovervollständigung), plus lokale Varianten je Stadtteil — und welche davon Ihre Website sichtbar beantwortet. Jede offene Frage ist eine fertige Seite oder ein FAQ-Eintrag, und Frage-Antwort-Abschnitte werden von KI-Assistenten überproportional oft zitiert."
    }, {
      title: "Verzeichnisse und Social-Präsenz",
      body: "Welche großen deutschen Verzeichnisse und Plattformen Sie führen — Gelbe Seiten, Das Örtliche, 11880, Yelp und weitere."
    }, {
      title: "NAP-Konsistenz",
      body: "Ob Name, Adresse und Telefonnummer über diese Einträge und Profile hinweg übereinstimmen. Widersprüchliche Daten schwächen Googles Vertrauen in Ihren Standort."
    }, {
      title: "Linkstruktur",
      body: "Ob jede wichtige Seite aus dem Hauptmenü erreichbar ist und ob interne Links ins Leere führen. Bestandenes wird ebenso berichtet wie Fehler."
    }, {
      title: "Verweisende Domains",
      body: "Wie viele unabhängige Websites auf Ihre Seite verlinken — ein Autoritätssignal, ausdrücklich kein Besucherzähler."
    }]
  },
  platforms: {
    eyebrow: "Plattform-Check",
    title: "Ist Ihr Unternehmen überall richtig eingetragen?",
    lead: "Wir prüfen nicht nur, wo Ihr Unternehmen erscheint. Der Bericht zeigt auch, ob Name, Adresse, Telefonnummer und Öffnungszeiten über wichtige Plattformen hinweg übereinstimmen.",
    checked: "wird geprüft",
    more: "+ 15 weitere Verzeichnisse und Plattformen"
  },
  how: {
    title: "So funktioniert's",
    steps: [{
      title: "Scan anfordern",
      body: "Firmenname und Ort genügen. Kein Login, kein Zugang zu Ihren Konten nötig."
    }, {
      title: "Kostenloser Kurzbericht per Link",
      body: "Score, die sechs Bereiche, Maps-Position, Heatmap und die Anzahl bestandener Kriterien je Bereich."
    }, {
      title: "Ausführlicher Bericht mit 3-Monats-Plan",
      body: "Jede Einzelfeststellung, alle Prüfungen im Detail und der priorisierte Plan — von einem Menschen geprüft."
    }]
  },
  report: {
    title: "So sieht Ihr Bericht aus",
    lead: "Ein Link, den Sie teilen können — mit Ihrer Agentur, Ihrem Webbetreuer oder Ihrem Team.",
    tabs: ["Übersicht", "Sichtbarkeit", "Reputation", "Recht & Struktur", "Aktionsplan"],
    business: "Friseur Müller · Wuppertal-Elberfeld",
    note: "Beispieldarstellung mit Musterwerten.",
    lockedRows: ["Einzelfeststellung: Meta-Titel auf 4 Seiten", "Einzelfeststellung: Bildquelle mit 8 Fundstellen", "Einzelfeststellung: Antwortquote auf Bewertungen"],
    locked: "Im ausführlichen Bericht enthalten"
  },
  pricing: {
    title: "Preise",
    lead: "Einmalig, kein Abo, kein Vertrag.",
    free: {
      name: "Kurzbericht",
      price: "kostenlos",
      items: ["Score aus 100 Punkten", "Die sechs Bereiche als Balken", "Google-Maps-Position", "Sichtbarkeits-Heatmap", "Anzahl der Verzeichniseinträge", "NAP-Score", "Anzahl bestandener Kriterien je Bereich (ohne Angabe, welche)"],
      cta: "Kostenlos prüfen"
    },
    paid: {
      name: "Ausführlicher Bericht",
      price: "39 €",
      priceNote: "einmalig",
      items: ["Jede Einzelfeststellung im Klartext", "Vollständige Verzeichnisliste", "Wo Ihre Kontaktdaten voneinander abweichen", "Rechte-Check inklusive Bildrechte-Prüfung", "Beide KI-Sichtbarkeitstests mit Tonalität je Nennung", "Tiefe Bewertungsanalyse mit Mitbewerber-Tabelle", "Priorisierter Drei-Monats-Plan"],
      cta: "Bericht anfordern",
      note: "Dies ist keine Rechtsberatung."
    }
  },
  services: {
    freeName: "Kostenloser Überblick",
    reportPriceNote: "einmalig",
    reportSlots: "Beratungsmonat für die ersten {total} Kunden inklusive: Noch {n} von {total} Plätzen.",
    reportCta: "Bericht anfordern",
    consultingName: "Beratung per Ticket",
    consultingPriceNote: "für {days} Tage",
    consultingItems: ["Fragen zu jeder Empfehlung Ihres Berichts", "Bis zu {max} Tickets", "Antwort innerhalb von {hours} Stunden (Mo–Fr)", "Schriftlich per Ticket, keine Telefonate"],
    consultingNote: "Setzt einen ausführlichen Bericht voraus.",
    consultingCta: "Beratung anfragen",
    bandTitle: "Umsetzung / Digitale Infrastruktur",
    bandBody: "Website-Neuaufbau oder einzelne Bausteine, etwa Google-Profil, lokale Einträge, strukturierte Daten oder Bewertungs-Einrichtung. Preis nach individuellem Angebot.",
    bandNote: "Keine Ranking-Versprechen: Wir setzen um, was der Bericht messbar als fehlend zeigt.",
    bandCta: "Angebot anfragen"
  },
  quote: {
    metaTitle: "Angebot anfragen — Positivup",
    title: "Angebot anfragen",
    lead: "Beschreiben Sie kurz, was Sie brauchen. Sie erhalten ein individuelles Angebot, keine Standardpreise und keine Ranking-Versprechen.",
    fields: {
      name: "Name",
      company: "Firma",
      email: "E-Mail",
      phone: "Telefon",
      scope: "Umfang",
      items: "Welche Bausteine?",
      message: "Nachricht"
    },
    optional: "optional",
    scopeFull: "Komplette Erneuerung (Website-Neuaufbau)",
    scopeItems: "Einzelbausteine",
    itemLabels: {
      website: "Website",
      google_profile: "Google-Unternehmensprofil",
      local_seo: "Lokale Einträge und Verzeichnisse",
      structured_data: "Strukturierte Daten",
      reviews_setup: "Bewertungen einrichten",
      ai_visibility: "Sichtbarkeit in KI-Antworten",
      other: "Sonstiges"
    },
    consent: "Ich bin damit einverstanden, dass Sie mich zu diesem Angebot kontaktieren.",
    consentLinkLabel: "Datenschutzerklärung",
    submit: "Anfrage senden",
    sending: "Wird gesendet …",
    successTitle: "Vielen Dank, Ihre Anfrage ist bei uns angekommen.",
    successBody: "Wir melden uns per E-Mail mit einem individuellen Angebot.",
    failure: "Die Anfrage konnte nicht gesendet werden. Bitte prüfen Sie Ihre Angaben und versuchen Sie es später erneut.",
    errors: {
      name: "Bitte geben Sie Ihren Namen an.",
      company: "Bitte geben Sie Ihre Firma an.",
      email: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
      items: "Bitte wählen Sie mindestens einen Baustein.",
      consent: "Bitte stimmen Sie der Kontaktaufnahme zu."
    }
  },
  form: {
    title: "Bericht anfordern",
    lead: "Wir melden uns mit Ihrem Kurzbericht als Link. Sie entscheiden danach, ob Sie den ausführlichen Bericht möchten.",
    fields: {
      company: "Firmenname",
      city: "Ort oder PLZ",
      website: "Website",
      email: "E-Mail",
      phone: "Telefon",
      message: "Nachricht"
    },
    placeholders: {
      company: "Friseur Müller",
      city: "42103 Wuppertal",
      email: "name@firma.de",
      website: "www.ihre-website.de",
      phone: "0202 123456"
    },
    optional: "optional",
    consent: "Ich bin damit einverstanden, dass Sie mich zu meinem Bericht kontaktieren.",
    consentLinkLabel: "Datenschutzerklärung",
    submit: "Anfrage senden",
    successTitle: "Vielen Dank — Ihre Anfrage ist notiert.",
    successBody: "Sie erhalten Ihren kostenlosen Kurzbericht als Link. Sollten Rückfragen zu Ihrem Standort bestehen, melden wir uns kurz.",
    errors: {
      company: "Bitte geben Sie Ihren Firmennamen an.",
      city: "Bitte geben Sie Ort oder PLZ an.",
      email: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
      consent: "Ohne Ihre Einwilligung können wir Sie nicht kontaktieren."
    }
  },
  faq: {
    title: "Häufige Fragen",
    items: [{
      q: "Wie lange dauert es?",
      a: "In der Regel ein bis zwei Werktage. Der Scan selbst läuft schnell, aber jeder Bericht wird vor dem Versand von einem Menschen geprüft."
    }, {
      q: "Welche Daten brauchen Sie von mir?",
      a: "Firmenname und Ort genügen für den Kurzbericht. Eine Website-Adresse macht die technische und rechtliche Prüfung genauer. Zugänge zu Ihren Konten benötigen wir nicht."
    }, {
      q: "Ist das DSGVO-konform?",
      a: "Wir werten ausschließlich öffentlich zugängliche Informationen aus und verwenden Ihre Kontaktdaten nur, um Ihnen Ihren Bericht zu senden. Details stehen in der Datenschutzerklärung."
    }, {
      q: "Was genau steckt im ausführlichen Bericht?",
      a: "Jede Einzelfeststellung im Klartext: die vollständige Verzeichnisliste, Abweichungen Ihrer Kontaktdaten, der Rechte-Check inklusive Bildrechte, beide KI-Sichtbarkeitstests mit Tonalität, die tiefe Bewertungsanalyse mit Mitbewerber-Tabelle und der priorisierte Drei-Monats-Plan."
    }, {
      q: "Muss ich etwas unterschreiben?",
      a: "Nein. Der Kurzbericht ist kostenlos, der ausführliche Bericht kostet 39 € einmalig. Kein Abo, kein Vertrag, keine Kündigungsfrist."
    }, {
      q: "Kann ich den Bericht an meine eigene Agentur weitergeben?",
      a: "Ja, ausdrücklich. Der Bericht ist so geschrieben, dass Ihre Agentur oder Ihr Webbetreuer direkt damit arbeiten kann — jede Feststellung nennt den konkreten nächsten Schritt."
    }, {
      q: "Ist das eine rechtliche Prüfung?",
      a: "Nein. Wir weisen auf typische Auffälligkeiten hin, etwa fehlende Pflichtangaben oder Bilder mit unklarer Herkunft. Dies ist keine Rechtsberatung — für eine verbindliche Bewertung wenden Sie sich an eine Rechtsanwältin oder einen Rechtsanwalt."
    }, {
      q: "Was ist die Sichtbarkeits-Heatmap?",
      a: "Ihre Maps-Position wird an vielen Punkten über die Stadt gemessen und farbig dargestellt. So sehen Sie, in welchen Stadtteilen Sie gefunden werden und in welchen nicht."
    }]
  },
  footer: {
    blurb: "Digitale Sichtbarkeit für lokale Unternehmen in Deutschland — messbar, verständlich, ohne Abo.",
    legal: [{
      label: "Impressum",
      to: "/impressum"
    }, {
      label: "Datenschutzerklärung",
      to: "/datenschutz"
    }, {
      label: "AGB",
      to: "/agb"
    }, {
      label: "Widerruf",
      to: "/widerruf"
    }],
    rights: "Alle Rechte vorbehalten.",
    disclaimer: "Dies ist keine Rechtsberatung."
  },
  heatmap: {
    title: "36 Messpunkte · Suchbegriff „Friseur“",
    avg: "Maps-Position (Ø)",
    organic: "Organische Position",
    you: "Ihr Standort",
    legend: ["Platz 1–3", "Platz 4–7", "ab Platz 8"]
  },
  social: {
    title: "Referenzen",
    body: "Hier stehen künftig echte Kundenstimmen und Referenzen. Bis dahin lassen wir diesen Platz bewusst leer — wir erfinden keine."
  },
  legal: {
    widerruf: {
      title: "Widerrufsbelehrung",
      intro: "Hinweise zum Widerrufsrecht bei Verbraucherverträgen.",
      sections: [{
        heading: "Widerrufsrecht",
        body: ["[Widerrufsbelehrung und Muster-Widerrufsformular für Verbraucher ergänzen.]"]
      }]
    },
    impressum: {
      title: "Impressum",
      intro: "Angaben gemäß § 5 DDG.",
      sections: [{
        heading: "Anbieter",
        body: ["[Firmenname / Inhaber]", "[Straße und Hausnummer]", "[PLZ und Ort], Deutschland"]
      }, {
        heading: "Kontakt",
        body: ["Telefon: [Telefonnummer]", "E-Mail: [E-Mail-Adresse]"]
      }, {
        heading: "Vertreten durch",
        body: ["[Name der vertretungsberechtigten Person]"]
      }, {
        heading: "Registereintrag und Umsatzsteuer",
        body: ["Registergericht: [falls vorhanden]", "Registernummer: [falls vorhanden]", "Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG: [falls vorhanden]"]
      }, {
        heading: "Verantwortlich für den Inhalt",
        body: ["[Name], [Adresse]"]
      }, {
        heading: "Streitschlichtung",
        body: ["[Angabe zur Teilnahme oder Nichtteilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle ergänzen.]"]
      }]
    },
    datenschutz: {
      title: "Datenschutzerklärung",
      intro: "Diese Website verwendet keine Analyse- oder Tracking-Dienste und lädt keine Schriftarten von externen Servern. Personenbezogene Daten erheben wir nur, wenn Sie uns über das Anfrageformular schreiben.",
      sections: [{
        heading: "Verantwortliche Stelle",
        body: ["[Firmenname / Inhaber], [Adresse], [E-Mail-Adresse]"]
      }, {
        heading: "Anfrageformular",
        body: ["Wenn Sie einen Bericht anfordern, verarbeiten wir Firmenname, Ort oder PLZ, E-Mail-Adresse sowie freiwillig angegebene Website-, Telefon- und Nachrichtenangaben. Zweck ist ausschließlich die Erstellung und Zusendung Ihres Berichts sowie eventuelle Rückfragen dazu.", "Rechtsgrundlage ist Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sowie die Anbahnung eines Vertragsverhältnisses (Art. 6 Abs. 1 lit. b DSGVO). Sie können Ihre Einwilligung jederzeit widerrufen."]
      }, {
        heading: "Erhebung öffentlicher Informationen",
        body: ["Für den Bericht werten wir öffentlich zugängliche Informationen über das von Ihnen genannte Unternehmen aus, etwa Ihre Website, Ihr Unternehmensprofil, Bewertungen und Verzeichniseinträge."]
      }, {
        heading: "Speicherdauer",
        body: ["[Speicherdauer und Löschkonzept ergänzen.]"]
      }, {
        heading: "Auftragsverarbeiter und Hosting",
        body: ["[Hosting-Anbieter, E-Mail-Versand und weitere Dienstleister mit Sitz ergänzen.]"]
      }, {
        heading: "Ihre Rechte",
        body: ["Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Zudem können Sie sich bei einer Datenschutz-Aufsichtsbehörde beschweren."]
      }, {
        heading: "Cookies",
        body: ["Diese Website setzt keine Cookies zu Analyse- oder Marketingzwecken. Sollten künftig solche Dienste eingesetzt werden, geschieht dies erst nach Ihrer ausdrücklichen Einwilligung."]
      }]
    },
    agb: {
      title: "Allgemeine Geschäftsbedingungen",
      intro: "Diese Bedingungen gelten für den kostenlosen Kurzbericht und den ausführlichen Bericht.",
      sections: [{
        heading: "1. Leistungsumfang",
        body: ["Der Kurzbericht ist kostenlos und enthält den Gesamtscore, die sechs Bereiche, die Google-Maps-Position, die Sichtbarkeits-Heatmap, die Anzahl der Verzeichniseinträge, den NAP-Score und die Anzahl bestandener Kriterien je Bereich.", "Der ausführliche Bericht kostet 39 € einmalig und enthält zusätzlich alle Einzelfeststellungen sowie den priorisierten Drei-Monats-Plan. Es entsteht kein Abonnement und keine Vertragsbindung."]
      }, {
        heading: "2. Zustandekommen des Vertrags",
        body: ["[Bestellablauf, Vertragsschluss und Zahlungsarten ergänzen.]"]
      }, {
        heading: "3. Widerrufsrecht",
        body: ["[Widerrufsbelehrung und Muster-Widerrufsformular für Verbraucher ergänzen.]"]
      }, {
        heading: "4. Grundlage der Auswertung",
        body: ["Die Auswertung beruht auf öffentlich zugänglichen Informationen zum Zeitpunkt der Messung. Positionen, Bewertungen und Antworten von KI-Assistenten verändern sich laufend; eine bestimmte Platzierung oder ein bestimmter Geschäftserfolg wird nicht zugesagt."]
      }, {
        heading: "5. Keine Rechtsberatung",
        body: ["Hinweise zu Impressum, Datenschutz, Einwilligungen und Bildrechten sind Auffälligkeiten aus einer automatisierten Prüfung mit menschlicher Sichtung. Dies ist keine Rechtsberatung. Für eine verbindliche Beurteilung wenden Sie sich an eine Rechtsanwältin oder einen Rechtsanwalt."]
      }, {
        heading: "6. Nutzung des Berichts",
        body: ["Sie dürfen den Bericht innerhalb Ihres Unternehmens frei verwenden und an Ihre Agentur oder Ihren Webbetreuer weitergeben."]
      }, {
        heading: "7. Haftung und Schlussbestimmungen",
        body: ["[Haftungsregelungen, anwendbares Recht und Gerichtsstand ergänzen.]"]
      }]
    }
  }
};